<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal" style="width: 100vw; margin-bottom: 1em;"></cv-tag>

    <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
      <cv-row>
        <cv-column :sm="2" :md="4" :lg="5">
          <data-valida etichetta="Dalla Data"
                       v-model="modello.dta_registrazione"
                       messaggio_non_valido="Data di registrazione non valida" />
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="5">
          <data-valida etichetta="Alla Data"
                       v-model="modello.dta_acquisto"
                       messaggio_non_valido="Data di acquisto non valida" />
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="5">
          <cv-text-input label="Numero Fattura d'Acquisto"
                         value="4"></cv-text-input>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label="Seleziona un fornitore"
                        title="Fornitore" :auto-filter="true"
                        v-model="modello_fornitore"
                        :options="fornitori"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <!-- Griglia per schermi medio grandi -->
        <cv-column :sm="0" :md="8" :lg="16">
          <cv-data-table :columns="colonne_materiali"
                         :data="righe_materiali"
                         helper-text="Materiali Acquistati" />
        </cv-column>
        <!-- Griglia per i cellulari -->
        <cv-column :sm="4" :md="0" :lg="0">
          <cv-structured-list v-for="(riga, indice) in righe_materiali" v-bind:key="indice">
            <template slot="items">
              <cv-structured-list-item v-for="(colonna, indice_colonna) in colonne_materiali" v-bind:key="indice_colonna">
                <cv-structured-list-data>
                  {{ colonna }}
                </cv-structured-list-data>
                <cv-structured-list-data>
                  {{ riga[indice_colonna] }}
                </cv-structured-list-data>
              </cv-structured-list-item>
            </template>
          </cv-structured-list>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="2" :lg="12">
          <cv-text-area
              label="Note"
              value=""></cv-text-area>
        </cv-column>
        <cv-column :sm="4" :md="2" :lg="4">
          <cv-text-input label="Totale" readonly
                         value="                                 € 61,00"></cv-text-input>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <Bottoniera testo_nuovo="Nuovo L. Tipo"
                testo_salva="Salva L. Tipo"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {
  name: "Acquisti",
  components: { Bottoniera },
  data: function() {
    return {
      modello: {
        dta_registrazione: "16/02/2021",
        dta_acquisto: "12/08/2021"
      },
      modello_fornitore: "Azienda Agricola Mario Rossi s.r.l",
      fornitori: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "1"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "2"
        }
      ],
      colonne_materiali: [
        "Descrizione",
        "Unità di Misura",
        "IVA",
        "Quantità",
        "Prezzo Unitario",
        "Imponibile",
        "Totale"
      ],
      righe_materiali: [
          [
              "Filtri",
              "Nr.",
              "22",
              "1",
              "€ 50,00",
              "€ 50,00",
              "€ 61,00"
          ]
      ]
    }
  }
}
</script>

<style scoped>

</style>